// Lightweight CMS client. Pages call fetchContent(category) and receive the
// `data` payload of each item ordered by `order`. On failure, callers fall back
// to their hardcoded defaults so the page never breaks.
const BASE = process.env.REACT_APP_BACKEND_URL;

export async function fetchContent(category) {
  try {
    const res = await fetch(`${BASE}/api/content/${category}`);
    if (!res.ok) throw new Error(`Failed ${res.status}`);
    const items = await res.json();
    return items.map((item) => ({ id: item.id, order: item.order, ...item.data }));
  } catch (err) {
    console.warn(`[contentApi] fetch '${category}' failed, using fallback`, err);
    return null;
  }
}

export async function fetchAllContent(token, category) {
  const url = new URL(`${BASE}/api/admin/content`);
  if (category) url.searchParams.set('category', category);
  const res = await fetch(url.toString(), { headers: { Authorization: `Bearer ${token}` } });
  if (!res.ok) throw new Error(`Failed ${res.status}`);
  return res.json();
}

export async function createContent(token, category, data, order = 0) {
  const res = await fetch(`${BASE}/api/admin/content`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${token}` },
    body: JSON.stringify({ category, data, order }),
  });
  if (!res.ok) throw new Error(`Failed ${res.status}`);
  return res.json();
}

export async function updateContent(token, id, { data, order }) {
  const body = {};
  if (data !== undefined) body.data = data;
  if (order !== undefined) body.order = order;
  const res = await fetch(`${BASE}/api/admin/content/${id}`, {
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${token}` },
    body: JSON.stringify(body),
  });
  if (!res.ok) throw new Error(`Failed ${res.status}`);
  return res.json();
}

export async function deleteContent(token, id) {
  const res = await fetch(`${BASE}/api/admin/content/${id}`, {
    method: 'DELETE',
    headers: { Authorization: `Bearer ${token}` },
  });
  if (!res.ok) throw new Error(`Failed ${res.status}`);
  return res.json();
}
